/* CookieConsent — text in English and German (same shape in both). */
import { ByLang, useL } from "i18n/lang";

const en = {
  aria: "Cookie consent",
  body: "We use cookies to keep you signed in, remember your preferences, and understand how Yogyism is used. By continuing, you agree to our use of cookies.",
  decline: "Decline",
  accept: "Accept",
};

export type CookieConsentText = typeof en;

const de: CookieConsentText = {
  aria: "Cookie-Einwilligung",
  body: "Wir verwenden Cookies, damit du angemeldet bleibst, deine Einstellungen gespeichert werden und wir verstehen, wie Yogyism genutzt wird. Wenn du fortfährst, stimmst du der Verwendung von Cookies zu.",
  decline: "Ablehnen",
  accept: "Akzeptieren",
};

export const cookieConsentText: ByLang<CookieConsentText> = { en, de };
export const useCookieConsentText = () => useL(cookieConsentText);
